export const BRAZE_CONTENT_CARD_FULLFILED = 'BRAZE_CONTENT_CARD_FULLFILED';

export const brazeContentCardCreator = cards => ({
  type: BRAZE_CONTENT_CARD_FULLFILED,
  payload: cards,
});
